"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m15.015 10.203-1.79 1.358a.34.34 0 0 1-.41.001l-1.325-.994a.85.85 0 0 0-1.23.227l-1.666 2.643c-.16.254.152.54.391.358l1.79-1.358a.34.34 0 0 1 .41-.001l1.325.994a.85.85 0 0 0 1.23-.227l1.666-2.643c.16-.254-.152-.54-.391-.358"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M12 3.75c-4.557 0-8.25 3.693-8.25 8.25s3.693 8.25 8.25 8.25 8.25-3.693 8.25-8.25S16.557 3.75 12 3.75m0 13.582a6.2 6.2 0 0 1-1.642-.218.45.45 0 0 0-.303.022l-1.126.497a.454.454 0 0 1-.637-.401l-.031-1.009a.45.45 0 0 0-.152-.323c-1.104-.987-1.781-2.416-1.781-4.069 0-3.161 2.477-5.502 5.672-5.502s5.672 2.34 5.672 5.502-2.477 5.502-5.672 5.502z"
        })
    ]
}), 'MessengerFilled'); //# sourceMappingURL=index.js.map
